export default {
  title: `Subscribe to the PennyLane newsletter`,
  description: `for exclusive QHack 2026 announcements and event updates.`,
  social: {
    twitterUrl: `https://twitter.com/PennyLaneAI`,
    linkedInUrl: `https://www.linkedin.com/company/pennylaneai/`,
    youTubeUrl: `https://www.youtube.com/@PennyLaneAI`,
    gitHubUrl: `https://github.com/PennyLaneAI/pennylane`,
    discordUrl: `https://discord.com/invite/gnySM3nrN3`,
  },
  policies: [
    {
      name: 'Terms and Conditions',
      link: '/terms-and-conditions',
    },
    {
      name: 'Privacy Policy',
      link: '/privacy-policy',
    },
    {
      name: 'Accessibility Policy',
      link: '/accessibility',
    },
    {
      name: 'Code of Conduct',
      link: '/code-of-conduct',
    },
  ],
  mailChimp: {
    baseURL: `https://pennylane.us17.list-manage.com/subscribe/post?u=725f07a1d1a4337416c3129fd&id=`,
    mailingList: `628ec6afb4&f_id=00c4e5e3f0`,
  },
}
